<template>
  <Table
    :columns="columns"
    :data="list"
    :loading="tableLoading"
    :noDataText="`<div class='no_data'>
        <img  src='${require('@/assets/images/nightImage.png')}'>
      <span class='text'> ${$t('暂无数据')} </span>
  </div>`"
  >
    <template #currency="{ row }">
      <span
        :style="
          row.positionData
            ? {
                color: '#3890f9',
                cursor: 'pointer',
              }
            : {}
        "
      >
        {{ `${row.contractNo.split('_')[0].toUpperCase()} ${row.lever}X` }}
      </span>
    </template>
    <template #profit="{ row }">
      <ProfitData :profitData="row" />
    </template>
    <template #category="{ row }">
      <span
        :style="{
          color: {
            BULL: '#02B999',
            BEAR: '#FF3F4A',
          }[row.direction],
        }"
      >
        {{ row.direction === 'BULL' ? $t('买入/做多') : $t('卖出/做空') }}
      </span>
    </template>
    <template #stop="{ row }">
      {{ `${+row.profitPrice || '--'}/${+row.lossPrice || '--'}` }}
    </template>
    <template #action="{ row }">
      <el-button
        v-if="row.positionData"
        type="text"
        style="color: #3890f9"
        @click="closePositioin('oneClickClosePositioin', row)"
      >
        {{ $t('一键平仓') }}
      </el-button>
      <template v-else>
        <el-button
          type="text"
          style="color: #3890f9"
          @click="$emit('modifyProfitAndLossPrice', row)"
        >
          {{ $t('止盈止损') }}
        </el-button>
        <el-button
          type="text"
          style="color: #3890f9"
          @click="closePositioin('closePositioin', row)"
        >
          {{ $t('平仓') }}
        </el-button>
      </template>
    </template>
  </Table>
</template>
<script>
import ProfitData from './ProfitData.vue'
export default {
  name: 'PositionTable',
  components: {
    ProfitData,
  },
  props: {
    columns: Array,
    list: Array,
    tableLoading: Boolean,
  },
  methods: {
    closePositioin(event, row) {
      this.$emit(event, row)
    },
  },
}
</script>
<style scoped lang="less">
.ivu-table-wrapper {
  ::v-deep .ivu-spin-fix {
    background: rgba(#0a0a0c, 0.8);
    .ivu-spin-dot {
      background-color: #fff;
    }
  }
  ::v-deep .ivu-table {
    background: none;

    &::before {
      content: none;
    }
    .ivu-table-header {
      table {
        height: 40px;
        border-collapse: unset;
      }
      th {
        background: #181a23;
        font-size: 14px;
        font-weight: 600;
        color: #b0b8db;
        border: none;
      }
    }
    .ivu-table-body {
      td {
        background: #252a44;
        font-size: 14px;
        font-weight: 600;
        color: #b0b8db;
        border-bottom-color: #333646;
      }
    }
    .ivu-table-tip {
      td {
        background: none;
        border: none;
      }
      span:not(.text) {
        position: relative;
        display: inline-block;
        height: 200px;
        width: 100%;
        .no_data {
          background-color: #252a44;
          width: 100%;
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          img {
            width: 44px;
            height: 40px;
            margin-bottom: 10px;
          }
          .text {
            font-size: 12px;
            font-weight: 500;
            color: var(--textColor2, #616888);
          }
        }
      }
    }
  }
}
</style>
